import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { FirebaseCampaignBannerComponent } from './firebase-campaign-banner.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
  ],
  exports: [
    FirebaseCampaignBannerComponent,
  ],
  declarations: [ FirebaseCampaignBannerComponent],
})
export class  FirebaseCampaignBannerModule {}
